import api from '@/api/index.js'

const pos_transactions = {
  state: {
    loading: false,
    data: [],
    pagination: {
      offset: 0,
      limit: 0,
      total: 0,
    },
    filterDetails: null,
    error: null
  },

  mutations: {
    SET_POS_TRANSACTIONS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_POS_TRANSACTIONS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_POS_TRANSACTIONS_ERROR: (state, error) => {
      state.error = error
    },
    SET_POS_TRANSACTIONS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadPosTransactions({commit}, query) {
      commit('SET_POS_TRANSACTIONS', {
        data: [],
        pagination: {
          offset: 0,
          limit: 0,
          total: 0,
        }
      })
      commit('SET_POS_TRANSACTIONS_ERROR', null)
      commit('SET_POS_TRANSACTIONS_FILTER_DETAILS', query)
      commit('SET_POS_TRANSACTIONS_LOADING', true)
      return api.get(`pos-transactions?date=${query.date}&tx_ref=${query.txRef}&limit=150&offset=0`)
        .then((response) => {
          commit('SET_POS_TRANSACTIONS', response)
        })
        .catch((error) => {
          commit('SET_POS_TRANSACTIONS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_POS_TRANSACTIONS_LOADING', false)
        })
    }
  }
}

export default pos_transactions
